export default __webpack_public_path__ + "static/media/downw.952c1b01.png";